import apis from "../../core/apis.js";

class BackupRecommendationResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }
  getBackupRecommendation(id) {
    return this.$resource(apis.backupRecommendation + id).get();
  }
  refreshBackupRecommendation(id, item) {
    return this.$resource(apis.backupRecommendation + id + "/refresh", null, {
      update: { method: "PUT" },
    }).update(item);
  }
  getBackupStatus(id) {
    return this.$resource(
      `${apis.backupRecommendation}${id}/check_status`,
      null,
      {
        get: {
          method: "GET",
          transformResponse(data, headers) {
            const response = {};
            response.data = JSON.parse(data);
            response.headers = headers();
            return response;
          },
        },
      }
    ).get();
  }
}
export default BackupRecommendationResource;



// WEBPACK FOOTER //
// ./src/resources/backupRecommendation/backupRecommendation.resource.js